import Shepherd from 'shepherd.js';
import { setCookieValue } from '@naturehouse/nh-essentials/lib/cookies/cookie';
import scrollToTarget from '@naturehouse/nh-essentials/lib/dom/scrollToTarget';
import './styles.pcss';

export enum TourCookieValues {
    completed = 'completed'
}

export default class Tour extends Shepherd.Tour {
    readonly #options: TourOptions = {
        name: 'tour',
        steps: []
    };

    constructor(tourOptions: TourOptions) {
        super({
            tourName: tourOptions.name,
            useModalOverlay: true,
            defaultStepOptions: {
                scrollTo: true,
                scrollToHandler: (element: HTMLElement): void => scrollToTarget(element, 200, true),
                popperOptions: {
                    modifiers: [
                        { name: 'offset', options: { offset: tourOptions.offset || [0, 15] } }
                    ]
                },
                cancelIcon: {
                    enabled: true
                }
            }
        });

        this.#options = { ...this.#options, ...tourOptions };

        this.addSteps(
            this.#options.steps.map((step: any) => ({
                ...step,
                when: {
                    show: (): void => this.#setCurrentStepCookie(this.getCurrentStep()?.id)
                }
            }))
        );

        this.#addEventListeners();
    }

    public cancel(): void {
        this.#setCompleteTourCookie();
        super.hide();
        this.trigger('hide');
    }

    public hide(): void {
        super.cancel();
        this.trigger('cancel');
    }

    public startTour(): void {
        if (this.#options.cookie?.length) {
            this.show(this.#options.cookie);
            return;
        }

        this.start();
    }

    #addEventListeners(): void {
        this.on('start', this.#setCurrentStepCookie.bind(this));

        const completeTourValues = ['complete', 'cancel'];
        completeTourValues.forEach((event: string) =>
            this.on(event, this.#setCompleteTourCookie.bind(this))
        );
    }

    #setCurrentStepCookie(id: string | undefined): void {
        if (!id) {
            return;
        }

        setCookieValue(this.#options.name, id, {
            'max-age': 31536000
        });
    }

    #setCompleteTourCookie(): void {
        setCookieValue(this.#options.name, TourCookieValues.completed, { 'max-age': 31536000 });
    }
}
